import React from 'react';
import { MaterialReactTable, type MRT_ColumnDef } from 'material-react-table';
import { Box } from '@mui/material';
import { PowerRankingRowData } from './types';

interface PerformanceTabProps {
  data: PowerRankingRowData[];
}

export function PerformanceTab({ data }: PerformanceTabProps) {
  const performanceColumns: MRT_ColumnDef<PowerRankingRowData>[] = [
    {
      accessorKey: 'teamName',
      header: 'Team',
      size: 150,
      enableHiding: false,
    },
    {
      accessorKey: 'winPctg',
      header: 'Win %',
      Cell: ({ cell }) => (
        <Box>{cell.getValue() as number !== undefined ? (Math.round(cell.getValue() as number * 1000) / 10) + "%" : '-'}</Box>
      ),
    },
    {
      accessorKey: 'winPctgRank',
      header: 'Win % Rank',
    },
    {
      accessorKey: 'winPctgAgainstMedian',
      header: 'Win % vs Median',
      Cell: ({ cell }) => (
        <Box>{cell.getValue() as number !== undefined ? (Math.round(cell.getValue() as number * 1000) / 10) + "%" : '-'}</Box>
      ),
    },
    {
      accessorKey: 'winPctgAgainstMedianRank',
      header: 'Median Rank',
    },
    {
      accessorKey: 'totalPoints',
      header: 'Total Points',
      Cell: ({ cell }) => (
        <Box>{Math.round(cell.getValue() as number)}</Box>
      ),
    },
    {
      accessorKey: 'totalPointsRank',
      header: 'Points Rank',
    },
  ];

  return (
    <MaterialReactTable 
      columns={performanceColumns} 
      data={data} 
      enableColumnActions={false}
      enablePagination={false}
      initialState={{
        sorting: [
          {
            id: 'winPctgRank',
            desc: false,
          },
        ],
        density: 'compact',
      }}
    />
  );
}
